import { CGU_VERSION, isCguVersionCurrent, isCguVersionOutdated } from './CguVersion';

export interface CguAcceptanceRecord {
  id: string;
  user_id: string;
  version_cgu: string;
  accepted_at: string;
  ip_address: string | null;
  user_agent: string | null;
  is_trial: boolean;
}

export interface CguStatus {
  accepted: boolean;
  version: string | null;
}

export function latestAcceptanceForUser(
  rows: readonly CguAcceptanceRecord[],
  userId: string,
): CguAcceptanceRecord | null {
  const mine = rows
    .filter((row) => row.user_id === userId)
    .sort((a, b) => b.accepted_at.localeCompare(a.accepted_at));
  return mine[0] ?? null;
}

/**
 * Afficher le modal seulement s’il n’y a aucune acceptation
 * ou si la version acceptée est antérieure à la version courante.
 * Une connexion normale avec version à jour → pas de modal.
 */
export function shouldShowCguModal(
  latest: CguAcceptanceRecord | null,
  currentVersion = CGU_VERSION,
): boolean {
  if (!latest) return true;
  if (isCguVersionCurrent(latest.version_cgu, currentVersion)) return false;
  return isCguVersionOutdated(latest.version_cgu, currentVersion);
}

export function toCguStatus(
  latest: CguAcceptanceRecord | null,
  currentVersion = CGU_VERSION,
): CguStatus {
  if (!latest) return { accepted: false, version: null };
  return {
    accepted: isCguVersionCurrent(latest.version_cgu, currentVersion),
    version: latest.version_cgu,
  };
}
